<template>

  <ui-card name="overview.location_type_overview" :is-loading="isLoading" :error="error" padded>
    <grouped-bar-chart v-if="data && data.length > 0" :data="data" />

    <div v-else-if="isLoading" class="blokk-chart">
      <div class="blokk shimmer blokk-legend">
        <div class="blokk-legend-item">
          <div class="blokk-legend-item-dot"></div>
          <div class="blokk-legend-item-text">----</div>
        </div>
        <div class="blokk-legend-item">
          <div class="blokk-legend-item-dot"></div>
          <div class="blokk-legend-item-text">----</div>
        </div>
        <div class="blokk-legend-item">
          <div class="blokk-legend-item-dot"></div>
          <div class="blokk-legend-item-text">----</div>
        </div>
        <div class="blokk-legend-item">
          <div class="blokk-legend-item-dot"></div>
          <div class="blokk-legend-item-text">----</div>
        </div>
        <div class="blokk-legend-item">
          <div class="blokk-legend-item-dot"></div>
          <div class="blokk-legend-item-text">----</div>
        </div>
      </div>
      <div class="blokk-y-axis">
        <div class="blokk-row">
          <div class="blokk shimmer is-extra-small blokk-text">--</div>
          <div class="blokk-line"></div>
        </div>
        <div class="blokk-row">
          <div class="blokk shimmer is-extra-small blokk-text">--</div>
          <div class="blokk-line"></div>
        </div>
        <div class="blokk-row">
          <div class="blokk shimmer is-extra-small blokk-text">--</div>
          <div class="blokk-line"></div>
        </div>
      </div>
      <div class="blokk-x-axis">
        <div class="blokk shimmer blokk-text">
          <div>--------</div>
          <div>---------</div>
          <div>-------</div>
        </div>
        <div class="blokk-line">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>

  </ui-card>

</template>

<script>
import { has } from 'lodash';
import { format, subDays, parse } from 'date-fns';
import GroupedBarChart from 'views/charts/GroupedBarChart';
import Api from 'services/Api';
import { card } from 'views/mixins';

export default {
  extends: card('filter-dates'),

  components: {
    GroupedBarChart,
  },

  methods: {
    makeQuery(params) {
      return {
        app_id: params.appId,
        transformations: [],
        sets: [
          {
            store: 'transports',
            measures: [
              {
                measure: 'all',
                agg: 'count',
                custom_id: 'count',
              },
            ],
            dimensions: [
              {
                dim: 'transport_mode',
                custom_id: 'transport_mode',
              },
            ],
            filters: [
              {
                scope: 'req',
                type: 'range',
                dim: 'isotime',
                begin: params.from,
                end: params.to,
              },
            ],
          },
        ],
      };
    },

    parseData(set) {
      const values = [0.67, 0.5, 0.33, 0.1, 0.05, 0.025, 0.01];
      const modes = ['retail', 'grocery', 'bar / restaurant', 'entertainment'];
      const data = [...Array(7)].map((d, i) => ({
        category: i + 1,
        values: modes.map(mode => ({
          mode: mode,
          value: values[i] * Math.random(),
        })),
      }));

      return data;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~scss/utilities/initial-variables.scss';
@import '~scss/utilities/derived-variables.scss';

.card-content {
  padding-top: 1rem;
}

.content {
  height: 100%;
}

.grouped-bar-chart {
  height: 100%;
}

.blokk-chart {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding-right: 1px;
}

.blokk-legend {
  display: flex;
  flex-wrap: wrap;
}

.blokk-legend-item {
  display: flex;
  align-items: center;
  margin-top: 0.5rem;
  margin-right: 1.625rem;

  &:last-child {
    margin-right: 0;
  }
}

.blokk-legend-item-dot {
  width: 0.375rem;
  height: 0.375rem;
  background-color: $grey-lighter;
  transform: rotate(45deg);
}

.blokk-legend-item-text {
  margin-left: 0.625rem;
  font-size: 0.875rem;
  line-height: 1.14;
}

.blokk-x-axis {
  padding-left: 2.1875rem;

  .blokk-text {
    display: flex;
    justify-content: space-around;
    font-size: $size-small;
  }

  .blokk-line {
    display: flex;
    justify-content: space-between;

    > div {
      width: 1px;
      height: 0.5rem;
      margin-top: -0.5rem;
      transform: translateY(-1.6875rem);
      background-color: $grey-darker;
      opacity: 0.4;
    }
  }
}

.blokk-y-axis {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  padding-top: 1.0625rem;
  padding-bottom: 0.375rem;

  .blokk-row {
    display: flex;
    align-items: center;
  }

  .blokk-text {
    flex: 0 0 2.1875rem;
    font-size: $size-small;
    line-height: 1.17;
  }

  .blokk-line {
    flex: 1;
    height: 1px;
    background-color: $grey-darker;
    opacity: 0.2;
  }
}
</style>